export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-Bold.a64a9abe.otf";